import { atom } from 'jotai';

/**
 * Global atom for settings data.
 * This will store the settings object returned from the /settings endpoint.
 *
 * Example usage:
 *   const [settings, setSettings] = useAtom(settingsAtom);
 */
export const settingsAtom = atom(null);

/**
 * Global atom for users/students data.
 * This will store the users array returned from the /teacher/students endpoint.
 *
 * Example usage:
 *   const [users, setUsers] = useAtom(usersAtom);
 */
export const usersAtom = atom([]);

// In the future, add more atoms here for students, events, etc. 
export const eventsAtom = atom([])

// Default: [first day of current month, last day of current month]
const now = new Date();
export const invoiceDateRangeAtom = atom([
    new Date(now.getFullYear(), now.getMonth(), 1),
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
]);

export const invoicesDataAtom = atom({ documents: [], expenses: [] }); 